<template>
  <div class="auto-login">
    <img class="auto-login__symbol" :src="symbol" />
    <v-progress-circular indeterminate color="primary" size="36" />
    <p class="auto-login__message">{{ $t('auth.autoLogin.signingIn') }}</p>
  </div>
</template>

<script>
import symbol from '@/assets/images/logo-hauseful-symbol-dark.svg'

import { autoLogin } from '@/services/auth/autoLogin'

/**
 * Landing spot for the one-time ticket minted at the end of self-service onboarding: trades it for
 * a session and drops the customer inside the product.
 *
 * The ticket is stripped from the URL before anything else happens, so it never reaches the browser
 * history or a Referer header on the next navigation. It is single-use and short-lived anyway —
 * this is the second lock, not the first.
 */
export default {
  name: 'AutoLogin',

  data: () => ({
    symbol,
  }),

  async created() {
    const token = this.$route.query.token

    if (token) {
      this.$router.replace({ query: {} })
    }

    const signedIn = await autoLogin(token)

    // getUser() already routes a signed-in user to the right home for their role; only the failure
    // path needs a destination here.
    if (!signedIn) this.$router.replace('/login')
  },
}
</script>

<style lang="scss" scoped>
.auto-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  min-height: 100vh;
}

.auto-login__symbol {
  width: 48px;
}

.auto-login__message {
  margin: 0;
  color: #7e939f;
  font-size: 15px;
}
</style>
